import { render, staticRenderFns } from "./ind_prg_horizontal.vue?vue&type=template&id=7e9da1cc&scoped=true"
import script from "./ind_prg_horizontal.vue?vue&type=script&lang=js"
export * from "./ind_prg_horizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9da1cc",
  null
  
)

export default component.exports